<template>
  <el-dialog :visible.sync="visible" title="费用设置" :close-on-click-modal="false" :close-on-press-escape="false"
    :append-to-body="true">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="外销合同：" prop="orderId">
            <order-drop v-model="dataForm.orderId" size="medium" valName="id"></order-drop>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="费用名称：" prop="name">
            <el-select v-model="dataForm.name" placeholder="请选择费用名称" allow-create default-first-option filterable
              style="width: 100%">
              <el-option v-for="item in defaultNameList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数量：" prop="count">
            <el-input v-model="dataForm.count" placeholder="数量"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="金额：" prop="amount">
            <el-input v-model="dataForm.amount" placeholder="金额"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="费用时间：" prop="operateTime">
            <el-date-picker v-model="dataForm.operateTime" type="date" value-format="yyyy-MM-dd" style="width: 100%"
              placeholder="选择费用时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票方：" prop="sellerReceiptId">
            <company-account v-model="dataForm.sellerReceiptId" size="medium"></company-account>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发票号：" prop="receiptCode">
            <el-input v-model="dataForm.receiptCode" placeholder="请输入发票号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门/车间：" prop="dept">
            <el-input v-model="dataForm.dept" placeholder="请输入部门/车间"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="6" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import CommonDrop from "@/components/CommonDrop";
import debounce from "lodash/debounce";
import { moneyValidator } from "@/utils/validate";
import CompanyAccount from '@/views/modules/trade/common/CompanyAccount'
import CostApi from "@/api/cost";
import dayjs from "dayjs";
export default {
  components: { CommonDrop, CompanyAccount },
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {
        id: "",
        orderId: "",
        name: "",
        count: 1,
        amount: "",
        operateTime: "",
        sellerReceiptId: '',
        receiptCode: '',
        dept: '',
        remark: '',

      },
      defaultNameList: ['运费', '包装箱', '外放加工费', '药剂']
    };
  },
  computed: {
    dataRule() {
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        amount: [
          { required: true, message: "请填写金额", trigger: "change" },
          { validator: moneyValidator, trigger: "change" },
        ],
        operateTime: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ]
      };
    },
  },
  methods: {
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.dataForm.orderId = ''
        this.dataForm.sellerReceiptId = ''
        this.dataForm.operateTime = dayjs().format("YYYY-MM-DD");
        if (this.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    async getInfo() {
      const data = await CostApi.getInfo(this.id)
      this.dataForm = {
        ...this.dataForm,
        ...data,
      };
    },

    async doPost() {
      let postForm = this.$copy(this.dataForm);
      const data = await CostApi.save(postForm)
      this.$message.success(data.msg || this.$t("prompt.success"));
      this.$emit("refreshDataList");
      this.cancel();
    },

    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.doPost()
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    cancel() {
      setTimeout(() => {
        this.visible = false;
      }, 500);
    },
  },
};
</script>
